'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Operation = require('../../../types/Operation.cjs');
var TransactionBuilder = require('../../../utils/TransactionBuilder.cjs');

// -----------------
// Operation
// -----------------

const Key = 'UnwrapCandyGuardOperation';

/**
 * Unwraps the given Candy Machine from its Candy Guard.
 *
 * This makes the Candy Machine authority its own mint authority again
 *
 * ```ts
 * await metaplex
 *   .candyMachines()
 *   .unwrapCandyGuard({
 *     candyMachine,
 *     candyGuard,
 *   };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const unwrapCandyGuardOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const unwrapCandyGuardOperationHandler = {
  async handle(operation, metaplex, scope) {
    return unwrapCandyGuardBuilder(metaplex, operation.input, scope).sendAndConfirm(metaplex, scope.confirmOptions);
  }
};

// -----------------
// Builder
// -----------------

/**
 * @group Transaction Builders
 * @category Inputs
 */

/**
 * Unwraps the given Candy Machine from its Candy Guard.
 *
 * This makes the Candy Machine authority its own mint authority again
 *
 * ```ts
 * const transactionBuilder = await metaplex
 *   .candyMachines()
 *   .builders()
 *   .unwrapCandyGuard({
 *     candyMachine,
 *     candyGuard,
 *   });
 * ```
 *
 * @group Transaction Builders
 * @category Constructors
 */
const unwrapCandyGuardBuilder = (metaplex, params, options = {}) => {
  const {
    programs,
    payer = metaplex.rpc().getDefaultFeePayer()
  } = options;
  const {
    candyGuard,
    candyGuardAuthority = metaplex.identity(),
    candyMachine,
    candyMachineAuthority = metaplex.identity()
  } = params;

  // Programs.
  const candyMachineProgram = metaplex.programs().getCandyMachine(programs);
  const candyGuardProgram = metaplex.programs().getCandyGuard(programs);
  return TransactionBuilder.TransactionBuilder.make().setFeePayer(payer).add({
    instruction: mplCandyGuard.createUnwrapInstruction({
      candyGuard,
      authority: candyGuardAuthority.publicKey,
      candyMachine,
      candyMachineProgram: candyMachineProgram.address,
      candyMachineAuthority: candyMachineAuthority.publicKey
    }, candyGuardProgram.address),
    signers: [candyGuardAuthority, candyMachineAuthority],
    key: params.unwrapCandyGuardInstructionKey ?? 'unwrapCandyGuard'
  });
};

exports.unwrapCandyGuardBuilder = unwrapCandyGuardBuilder;
exports.unwrapCandyGuardOperation = unwrapCandyGuardOperation;
exports.unwrapCandyGuardOperationHandler = unwrapCandyGuardOperationHandler;
//# sourceMappingURL=unwrapCandyGuard.cjs.map
